const { getLessonTypeClassification } = require('./lessonTypes');

function allowsGroupExpansion(schoolClass = {}, type = {}) {
  if (typeof schoolClass.allowGroupExpansion === 'boolean') return schoolClass.allowGroupExpansion;
  const classification = getLessonTypeClassification(type);
  return classification.isGroup || classification.isPair;
}

function joiningAvailability(schoolClass, type, count) {
  if (!Number.isInteger(type.maxStudents) || type.maxStudents < 1 || !Number.isInteger(count) || count < 0) return 'unknown';
  const limit = allowsGroupExpansion(schoolClass, type) ? 6 : type.maxStudents;
  return count < limit ? 'available' : 'full';
}

function normalizePublicClassFields(record) {
  const result = { ...record };
  if (result.allowGroupExpansion !== undefined && typeof result.allowGroupExpansion !== 'boolean') {
    throw Object.assign(new Error('Zgoda na powiększenie musi być wartością logiczną.'), { statusCode: 400 });
  }
  ['publicLevel', 'publicAge'].forEach(field => {
    if (result[field] !== undefined) {
      if (typeof result[field] !== 'string' || result[field].trim().length > 80) {
        throw Object.assign(new Error('Publiczna etykieta musi być tekstem do 80 znaków.'), { statusCode: 400 });
      }
      result[field] = result[field].trim();
    }
  });
  return result;
}

module.exports = { allowsGroupExpansion, joiningAvailability, normalizePublicClassFields };
